/**
 * Shared vertical offset contract for fixed Command Center chrome.
 *
 * Status bars mount independently above the application shell. Consumers must
 * use these helpers instead of hard-coding `top: 48px`, otherwise a status bar
 * can cover the Sidebar, AppDock, tabs, or another fixed shell surface.
 */
export const DEV_ENV_OFFSET_VAR = "--cc-dev-env-offset";
export const EDIT_MODE_OFFSET_VAR = "--cc-edit-mode-offset";

const statusOffsets =
  `var(${DEV_ENV_OFFSET_VAR}, 0px) + var(${EDIT_MODE_OFFSET_VAR}, 0px)`;

export function shellChromeTop(baseOffset = 0): string {
  return `calc(${baseOffset}px + ${statusOffsets})`;
}

export function shellChromeHeight(baseOffset = 0): string {
  return `calc(100vh - ${baseOffset}px - var(${DEV_ENV_OFFSET_VAR}, 0px) - var(${EDIT_MODE_OFFSET_VAR}, 0px))`;
}

